import * as Yup from 'yup'

export const getInitialValues = () => ({
  cmrNumber: '',
  truckNumber: '',
  driverName: '',
  providerName: ''
})

export const getValidationSchema = () =>
  Yup.object().shape({
    cmrNumber: Yup.string()
      .required('Număr CMR este obligatoriu.')
      .max(7, 'Valoare prea mare pentru CMR. Maxim 7 caractere'),
    truckNumber: Yup.string().required('Număr camion este obligatoriu.'),
    driverName: Yup.string().required('Nume șofer este obligatoriu.'),
    providerName: Yup.string().required('Firmă colectoare este obligatorie.')
  })
